import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CSpinner } from '@coreui/react';
import { Logout } from '../actions';

interface LogoutPageProps {
  authed: boolean;
}

function LogoutPage({ authed }: LogoutPageProps) {

  const dispatch = useDispatch();
  const history = useHistory();

  dispatch(new Logout());

  useEffect(() => {
    if (!authed) {
      history.push('/');
    }
  }, [authed]);

  return (
    <>
      <div className="c-app c-default-layout flex-row align-items-center justify-content-center">
        <CSpinner
          className="primary-color"
          style={{width:'3rem', height:'3rem'}}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  authed: state.login && state.login.authed,
});

export default connect(mapStateToProps)(LogoutPage);
